// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__bGFOj","title":"ClientCherryInfo_title__kdXrX","itemText":"ClientCherryInfo_itemText__OFFQC"};